import React from "react";
import Chart from "react-apexcharts";
import { BoxAnalytic } from "../../pages/analytic/styles";

interface BoxAnalyticCharBarProps {
  title: string;
  values: number[];
  amounts?: number[];
  descriptions: string[];
  obs?: JSX.Element;
  colors?: string[];
  height?: number | string;
  distributed?: boolean;
  horizontal?: boolean;
}

export const BoxAnalyticCharBar = ({
  title,
  values,
  amounts,
  descriptions,
  obs,
  colors,
  height = 200,
  distributed = true,
  horizontal = true,
}: BoxAnalyticCharBarProps) => {
  return (
    <BoxAnalytic>
      <h3>{title}</h3>

      <div style={{ width: "100%" }}>
        <Chart
          type="bar"
          height={height}
          series={[
            {
              name: "QTD",
              data: values,
            },
          ]}
          options={{
            chart: {
              toolbar: {
                show: false,
              },
            },
            colors: colors,

            plotOptions: {
              bar: {
                distributed: distributed,
                borderRadius: 4,
                horizontal: horizontal,
                dataLabels: {
                  position: "top",
                },
              },
            },
            dataLabels: {
              enabled: true,
              style: {
                fontSize: "12px",
                colors: ["#304758"],
              },
            },

            xaxis: {
              labels: {
                show: false,
              },

              categories: descriptions,
            },

            tooltip:
              (amounts?.length ?? 0) > 0
                ? {
                    enabled: true,
                    shared: false,
                    intersect: true,
                    y: {
                      formatter: (value, { dataPointIndex }) => {
                        const amount = amounts ? amounts[dataPointIndex] : null;
                        return amount !== null
                          ? `${value} ( ${amount.toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })} )`
                          : `${value}`;
                      },
                    },
                    x: {
                      formatter: (value) => `Descrição: ${value}`,
                    },
                  }
                : {
                    enabled: true,
                  },
          }}
        />
        {obs && <span className="span-alert">{obs}</span>}
      </div>
    </BoxAnalytic>
  );
};
